<template>
  <div>
    <BContainer fluid class="mt-3">
      <BRow>
        <BCol>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3 border-bottom border-light">
            <h5>マイページ</h5>
            <div class="d-flex float-right">
            </div>
          </div>
        </BCol>
      </BRow>
      <BRow>
        <BCol>
          <BCardGroup deck>
            <BCard header="ユーザーデータ" header-tag="header" class="shadow-sm" v-if="userData" key="userData">
              <BRow>
                <BCol class="col-md-3">
                  <BCard class="text-center h-100" :title="l_userName"
                    :sub-title="l_userAttributes && l_userAttributes['custom:company']">
                    <BCardText>{{ l_userAttributes && l_userAttributes["custom:organization"] }}</BCardText>
                    <BAvatar class="mx-auto" style="
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  " variant="secondary">
                      <i class="bi bi-person-fill" style="
    font-size: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  "></i>
                    </BAvatar>
                  </BCard>
                </BCol>
                <BCol class="col-md-9">
                  <BCard class="h-100">
                    <div class="d-flex mb-3 border-bottom border-light">
                      <div style="width:250px;">
                        <h6>都道府県</h6>
                      </div>
                      <div>
                        <h5>{{ l_userAttributes && l_userAttributes["custom:pref"] }}</h5>
                      </div>
                    </div>
                    <div class="d-flex mb-3 border-bottom border-light">
                      <div style="width:250px;">
                        <h6>市区町村</h6>
                      </div>
                      <div>
                        <h5>{{ l_userAttributes && l_userAttributes["custom:city"] }}</h5>
                      </div>
                    </div>
                    <div class="d-flex mb-3 border-bottom border-light">
                      <div style="width:250px;">
                        <h6>登録サービス</h6>
                      </div>
                      <div>
                        <h5>{{ l_userAttributes && l_userAttributes["custom:industry"] }}</h5>
                      </div>
                    </div>
                    <div class="d-flex mb-3 border-bottom border-light">
                      <div style="width:250px;">
                        <h6>識別ID</h6>
                      </div>
                      <div>
                        <h5>{{ l_userAttributes && l_userAttributes["sub"] }}</h5>
                      </div>
                    </div>
                    <div class="d-flex mb-3 border-bottom border-light">
                      <div style="width:250px;">
                        <div class="data-test-secion">
                          <div class="form-formField">
                            <div class="input-inputLabel"></div>
                            <BButton class="mypage-button" @click="handleSignOut">サインアウト</BButton>
                          </div>
                        </div>
                      </div>
                      <div style="width:250px;">
                        <div class="data-test-secion">
                          <div class="form-formField">
                            <div class="input-inputLabel"></div>
                            <BButton class="mypage-button" @click="watchChangePassword">パスワード変更</BButton>
                          </div>
                        </div>
                      </div>
                      <div style="width:250px;">
                        <div class="data-test-secion">
                          <div class="form-formField">
                            <div class="input-inputLabel"></div>
                            <BButton class="mypage-button" @click="watchLicense">法的情報表示</BButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </BCard>
                </BCol>
              </BRow>
            </BCard>
            <BCard no-body class="shadow-sm" v-if="passwordchange" key="passwordchange">
              <ChangePasswordModule ref="stationmapmodule" :handleClosePassword="watchMypage"></ChangePasswordModule>
            </BCard>
            <BCard header="法的情報" header-tag="header" class="shadow-sm" v-if="userLicense" key="userLicense">
              <div class="license-container" style="height: 650px; overflow-y: auto; padding: 20px;">
                <div class="license-content">
                  <h5>本製品に含まれるソフトウェアについて</h5>
                  <p>本製品には、以下のソフトウェアが含まれています。</p>
                  <ol style="line-height: 1.8;">
                    <li>パナソニック株式会社(「パナソニック」)により、またはパナソニックのために開発されたソフトウェア</li>
                    <li>パナソニックにライセンスされた第三者所有のソフトウェア</li>
                    <li>GNU GENERAL PUBLIC LICENSE Version 2(「GPL」)に基づいてライセンスされたソフトウェア</li>
                    <li>GNU LESSER GENERAL PUBLIC LICENSE Version 2.1(「LGPL」)に基づいてライセンスされたソフトウェア</li>
                    <li>GPL, LGPL以外に基づいてライセンスされたオープンソースソフトウェア</li>
                  </ol>

                  <hr class="my-4">

                  <h5>オープンソースソフトウェアライセンス情報</h5>

                  <div class="license-section mt-4 p-3" style="background-color: #f8f9fa; border-left: 4px solid #0d6efd; border-radius: 4px;">
                    <h6 class="mb-3"><strong>Bootstrap Icons</strong></h6>
                    <p class="mb-2">
                      <strong>Copyright:</strong> © 2019-2024 The Bootstrap Authors<br>
                      <strong>License:</strong> MIT License
                    </p>

                    <div class="mt-3 p-3" style="background-color: white; border-radius: 4px; font-family: monospace; font-size: 0.85rem; line-height: 1.6;">
                      <p><strong>MIT License</strong></p>
                      <p>
                        Permission is hereby granted, free of charge, to any person obtaining a copy
                        of this software and associated documentation files (the "Software"), to deal
                        in the Software without restriction, including without limitation the rights
                        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                        copies of the Software, and to permit persons to whom the Software is
                        furnished to do so, subject to the following conditions:
                      </p>
                      <p>
                        The above copyright notice and this permission notice shall be included in all
                        copies or substantial portions of the Software.
                      </p>
                      <p>
                        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                        SOFTWARE.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </BCard>
          </BCardGroup>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ChangePasswordModule from './../modules/ChangePasswordModule.vue'
import { Auth } from 'aws-amplify'

export default defineComponent({
  components: {
    ChangePasswordModule
  },
  data() {
    return {
      userData: true,
      userLicense: false,
      passwordchange: false,
      height: window.innerHeight
    }
  },
  computed: {
    l_userAttributes() {
      return this.$store.getters.userAttributes
    },
    l_userName() {
      return this.$store.getters.userName
    }
  },
  watch: {
    l_userAttributes(newVal, oldVal) {
      console.log(newVal, oldVal)
    }
  },
  methods: {
    async updateAttributes(value) {
      const user = await Auth.currentAuthenticatedUser()
      await Auth.updateUserAttributes(user, value)
    },
    watchMypage(susccesflg) {
      this.userData = true
      this.passwordchange = false
      this.userLicense = false

      if (susccesflg === 0) {
        const title = "パスワード変更成功"
        const msg = "パスワードを変更しました"
        this.showErrorMessageToast(title, msg, 'info')
      }
    },
    watchLicense() {
      this.userData = false
      this.passwordchange = false
      this.userLicense = true
    },
    watchChangePassword() {
      this.userData = false
      this.passwordchange = true
      this.userLicense = false
    },
    async handleSignOut() {
      try {
        await Auth.signOut()
        // Vuexストアから完全にユーザー情報をクリア
        this.$store.commit('setUser', null)
        this.$store.commit('setUserSignInStatus', false)
        this.$router.push('/signin')
      } catch (error) {
        console.error('SignOut error:', error)
      }
    }
  }
})
</script>
